export function transformAriaKebabCase(props) {
    const ariaAttributes = {};
    Object.entries(props).forEach(([key, value]) => {
        if (typeof key === 'string' && key.startsWith('aria')) {
            const transformedKey = `aria-${key.slice(4).toLowerCase()}`;
            ariaAttributes[transformedKey] = value;
        }
    });
    return ariaAttributes;
}
//# sourceMappingURL=transformAriaKebabCase.js.map